var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpendTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668,
    height: 41,
    viewBox: "0 0 668 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8261 0L10.5157 40.8029H0L40.3104 0",
    fill: "#FFF761"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.521 0.197144L29.2106 41H18.6948L59.0052 0.197144",
    fill: "#FFF761"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2153 0.197021L47.9049 40.9999H37.3892L77.6995 0.197021",
    fill: "#FFF761"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M668 0.197021L627.69 40.9999H47.5898L87.9002 0.197021",
    fill: "url(#paint0_linear_884_195444)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_884_195444",
    x1: 22.0538,
    y1: 41,
    x2: 604.74,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF761",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DF6F5",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendTitle);
export default __webpack_public_path__ + "static/media/spend-title.8e10681abd92f675751f5bdaeb8ab73e.svg";
export { ForwardRef as ReactComponent };